module.exports = __webpack_public_path__ + "static/media/advanced-web-scraping.89b7f48a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/serviceicon2/advanced-web-scraping.svg
// module id = 418
// module chunks = 0